import { BuiltinType } from './types';
export class BuiltinValueObject {
    constructor() {
        this.types = new Set([BuiltinType.ValueObject]);
    }
}

//# sourceMappingURL=BuiltinValueObject.js.map
